<template>
    <table class="outer">
        <tbody>
            <tr v-if="!showDataSaknas && datarader.length > 0" class="headerrad">
                <th class="label" style="width: 50%;">{{ mobilRubrik.namn }}</th>
                <td v-for="rubrik in mobilRubrik.value" class="cell">{{ rubrik }}</td>
            </tr>
            <tr v-if="showDataSaknas" class="rad empty">
                <th class="label" style="width: 50%;" aria-label="Inget värde"></th>
                <td colspan="3" style="line-height: 23px; text-wrap: balance; border-bottom: none;" class="empty">
                    <div class="messagecontainer" data-toggle="tooltip" data-trigger="hover" data-placement="bottom"
                        data-original-title="Det här urvalet har inte genomförts för den här utbildningen. Prova att byta till ett annat visningsalternativ.">
                        Data saknas för detta visningsalternativ</div>
                </td>
            </tr>
            <tr v-if="!showDataSaknas && datarader.length === 0" class="rad">
                <th class="label" style="line-height: 23px; width: 50%;" aria-label="Inget värde"></th>
                <td colspan="3" style="line-height: 23px; text-wrap: balance; border-bottom: none;" class="empty">
                    <div class="messagecontainer" data-toggle="tooltip" data-trigger="hover" data-placement="bottom"
                        data-original-title="Ingen vald urvalsgrupp för den här utbildningen. Prova att visa fler urvalsgrupper">
                        Ingen vald urvalsgrupp för den här utbildningen.<br>Prova att visa fler
                        urvalsgrupper.</div>
                </td>
            </tr>
            <tr v-for="(datarad, radindex) in datarader" class="rad">
                <th class="label" style="line-height: 23px;">{{ getNamn(datarad.namn) }}</th>
                <td v-for="(value, cellindex) in datarad.value" class="cell" :colspan="datarad.isMessage ? 3 : 1"
                    :style="datarad.isMessage ? 'line-height: 23px; text-wrap: balance;' : ''"
                    :class="datarad.isMessage ? 'empty' : ''"
                    :id="'cell-' + item.anmälningskod + '-' + datarad.namn + '-' + radindex + '-' + cellindex">
                    <div v-if="datarad.isMessage" class="messagecontainer" data-toggle="tooltip" data-trigger="hover"
                        data-placement="bottom"
                        data-original-title="Urvalsgruppen användes inte till den här utbildningen.">
                        Urvalsgruppen användes inte för den här utbildningen.<br>Prova att visa fler
                        urvalsgrupper.</div>
                    <span v-else :data-toggle="value === '-' || value === '*' ? 'tooltip' : ''"
                        :data-trigger="value === '-' || value === '*' ? 'hover' : ''"
                        :data-placement="value === '-' || value === '*' ? 'bottom' : ''"
                        :data-original-title="value === '-' ? 'Det fanns inga platser i urvalsgruppen.' : value === '*' ? 'Alla behöriga sökande i urvalsgruppen blev antagna.' : ''">
                        {{ value }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { AstaResultItemType, Sok, Urval, Urvalsgrupper } from '../../types/AstaTypes';
import useAstaStore from '../stores/AstaStore';

type Datarad = {
    namn: string;
    value: string[];
    isMessage: boolean;
};
const store = useAstaStore();
const props = defineProps<{
    item: AstaResultItemType,
}>();

const mobilRubrik = computed(() => {
    let datarad: Datarad = {} as Datarad
    if (store.display.vy === 'antagningspoang-urv1' || store.display.vy === 'antagningspoang-urv2') {
        datarad.namn = 'Urvalsgrupp';
        datarad.value = ['Poäng', 'Antagna', 'Reserver'];
    } else if (store.display.vy === 'reserver-och-antagna-urv1' || store.display.vy === 'reserver-och-antagna-urv2' || store.display.vy === 'sokande-sok') {
        datarad.namn = 'Titel';
        datarad.value = ['Antal'];
    } else if (store.display.vy === 'konsfordelning-urv1' || store.display.vy === 'konsfordelning-urv2') {
        datarad.namn = 'Kön';
        datarad.value = ['Antagna', 'Reserver'];
    } else if (store.display.vy === 'aldersfordelning-urv1' || store.display.vy === 'aldersfordelning-urv2') {
        datarad.namn = 'Åldersintervall';
        datarad.value = ['Antagna', 'Reserver'];
    } else if (store.display.vy === 'konsfordelning-sok') {
        datarad.namn = 'Kön';
        datarad.value = ['Antagna'];
    } else if (store.display.vy === 'aldersfordelning-sok') {
        datarad.namn = 'Åldersintervall';
        datarad.value = ['Antagna'];
    }
    return datarad;
});
const showDataSaknas = computed(() => {
    if (store.display.vy.endsWith('sok')) {
        return props.item.sok === null;
    } else if (store.display.vy.endsWith('urv1')) {
        return props.item.urval1 === null;
    } else if (store.display.vy.endsWith('urv2')) {
        return props.item.urval2 === null;
    }
});
const urvalsgruppBISaknas = computed(() => {
    let saknas = true;
    if (!store.display.urvalsgrupper.includes('BI')) {
        return false;
    }
    if (store.display.vy === 'antagningspoang-urv1') {
        props.item.urval1?.urvalsgrupper.some((urvalsgrupp) => {
            if (urvalsgrupp.urvalsgruppId === 'BI') {
                saknas = false;
            }
        });
    } else if (store.display.vy === 'antagningspoang-urv2') {
        props.item.urval2?.urvalsgrupper.forEach((urvalsgrupp) => {
            if (urvalsgrupp.urvalsgruppId === 'BI') {
                saknas = false;
            }
        });
    } else {
        saknas = false;
    }
    return saknas;
});
const urvalsgruppHPSaknas = computed(() => {
    let saknas = true;
    if (!store.display.urvalsgrupper.includes('HP')) {
        return false;
    }
    if (store.display.vy === 'antagningspoang-urv1') {
        props.item.urval1?.urvalsgrupper.some((urvalsgrupp) => {
            if (urvalsgrupp.urvalsgruppId === 'HP') {
                saknas = false;
            }
        });
    } else if (store.display.vy === 'antagningspoang-urv2') {
        props.item.urval2?.urvalsgrupper.forEach((urvalsgrupp) => {
            if (urvalsgrupp.urvalsgruppId === 'HP') {
                saknas = false;
            }
        });
    } else {
        saknas = false;
    }
    return saknas;
});
const getNamn = (urvalsgruppId: string) => {
    let namn = urvalsgruppId;
    if (urvalsgruppId === 'BI') {
        namn = store.texter.searchresultblock.selecttiongroup.BI.line1 + ' ' + store.texter.searchresultblock.selecttiongroup.BI.line2 + ' (' + urvalsgruppId + ')'
    } else if (urvalsgruppId === 'BII') {
        namn = store.texter.searchresultblock.selecttiongroup.BII.line1 + ' ' + store.texter.searchresultblock.selecttiongroup.BII.line2 + ' (' + urvalsgruppId + ')'
    } else if (urvalsgruppId === 'BF') {
        namn = store.texter.searchresultblock.selecttiongroup.BF + ' (' + urvalsgruppId + ')'
    } else if (urvalsgruppId === 'HP') {
        namn = store.texter.searchresultblock.selecttiongroup.HP + ' (' + urvalsgruppId + ')'
    }
    return namn;
};

const datarader = computed(() => {
    let datarader: Datarad[] = [];
    let hasUrvalsgrupper = false;
    if (store.display.vy.endsWith('urv1') && props.item.urval1 != null) {
        if (store.display.vy === 'antagningspoang-urv1') {
            props.item.urval1?.urvalsgrupper.forEach((urvalsgrupp) => {
                let tmp = urvalAntagningspoängDatarad(urvalsgrupp);
                if (tmp) {
                    datarader.push(tmp);
                }
            });
            hasUrvalsgrupper = true
        } else if (store.display.vy === 'reserver-och-antagna-urv1') {
            datarader = datarader.concat(urvalReserverAntagnaDatarad(props.item.urval1));
        } else if (store.display.vy === 'konsfordelning-urv1') {
            datarader = datarader.concat(urvalKönsfördelningDatarad(props.item.urval1));
        } else if (store.display.vy === 'aldersfordelning-urv1') {
            datarader = datarader.concat(urvalÅldersfördelningDatarad(props.item.urval1));
        }
    } else if (store.display.vy.endsWith('urv2') && props.item.urval2 != null) {
        if (store.display.vy === 'antagningspoang-urv2') {
            props.item.urval2?.urvalsgrupper.forEach((urvalsgrupp) => {
                let tmp = urvalAntagningspoängDatarad(urvalsgrupp);
                if (tmp) {
                    datarader.push(tmp);
                }
            });
            hasUrvalsgrupper = true
        } else if (store.display.vy === 'reserver-och-antagna-urv2') {
            datarader = datarader.concat(urvalReserverAntagnaDatarad(props.item.urval2));
        } else if (store.display.vy === 'konsfordelning-urv2') {
            datarader = datarader.concat(urvalKönsfördelningDatarad(props.item.urval2));
        } else if (store.display.vy === 'aldersfordelning-urv2') {
            datarader = datarader.concat(urvalÅldersfördelningDatarad(props.item.urval2));
        }
    } else if (store.display.vy.endsWith('sok') && props.item.sok != null) {
        if (store.display.vy === 'sokande-sok') {
            datarader = datarader.concat(sokReserverAntagnaDatarad(props.item.sok));
        } else if (store.display.vy === 'konsfordelning-sok') {
            datarader = datarader.concat(sokKönsfördelningDatarad(props.item.sok));
        } else if (store.display.vy === 'aldersfordelning-sok') {
            datarader = datarader.concat(sokÅldersfördelningDatarad(props.item.sok));
        }
    }
    if (hasUrvalsgrupper) {
        if (store.display.urvalsgrupper.length === 0) {
            if (datarader.length > 0 && !datarader.some((x: Datarad) => x.namn === 'BI')) {
                datarader.push(emptyDatarad('BI'));
            }
            if (datarader.length > 0 && !datarader.some((x: Datarad) => x.namn === 'HP')) {
                datarader.push(emptyDatarad('HP'));
            }
        } else {
            if (urvalsgruppBISaknas.value) {
                datarader.push(emptyDatarad('BI'));
            }
            if (urvalsgruppHPSaknas.value) {
                datarader.push(emptyDatarad('HP'));
            }
        }
        const valuesToSortInOrder = ['BI', 'BII', 'BF', 'HP', 'AU', 'SA', 'ÖS'];
        datarader.sort((a, b) => {
            const aIndex = valuesToSortInOrder.indexOf(a.namn.toUpperCase());
            const bIndex = valuesToSortInOrder.indexOf(b.namn.toUpperCase());
            if (aIndex === -1 && bIndex === -1) {
                return 0;
            }
            if (aIndex === -1) {
                return 1;
            }
            if (bIndex === -1) {
                return -1;
            }
            return aIndex - bIndex;
        });
    }
    return datarader;
});

/**funktioner för att välja och översätta data */
function emptyDatarad(urvalsgruppId: string) {
    return {
        namn: urvalsgruppId,
        value: ['Urvalsgruppen användes inte till den här utbildningen.'],
        isMessage: true
    } as Datarad;
}
function urvalAntagningspoängDatarad(urvalsgrupp: Urvalsgrupper) {
    let inkluderaUrvalsgrupp = store.display.urvalsgrupper.length === 0;
    if (!inkluderaUrvalsgrupp) {
        inkluderaUrvalsgrupp = store.display.urvalsgrupper.includes(urvalsgrupp.urvalsgruppId);
    }
    if (!inkluderaUrvalsgrupp) {
        return;
    }
    let tmp = [];
    tmp.push(String(urvalsgrupp.lägstaAntagnaPoäng));
    tmp.push(String(urvalsgrupp.antagna));
    tmp.push(String(urvalsgrupp.reserver));
    return {
        namn: urvalsgrupp.urvalsgruppId,
        value: tmp
    } as Datarad;
}
function urvalReserverAntagnaDatarad(urval: Urval) {
    const rader: Datarad[] = [];
    let tmpAntagna = [];
    let tmpReserver = [];
    tmpAntagna.push(String(urval.antagna));
    tmpReserver.push(String(urval.reserver));
    rader.push({
        namn: 'Antagna',
        value: tmpAntagna,
        isMessage: false
    });
    rader.push({
        namn: 'Reserver',
        value: tmpReserver,
        isMessage: false
    });
    return rader;
}
function urvalKönsfördelningDatarad(urval: Urval) {
    const rader: Datarad[] = [];
    let tmpMän = [];
    let tmpKvinnor = [];
    tmpMän.push(String(urval.manligaAntagna));
    tmpMän.push(String(urval.manligaReserver));
    tmpKvinnor.push(String(urval.kvinnligaAntagna));
    tmpKvinnor.push(String(urval.kvinnligaReserver));
    rader.push({
        namn: 'Män',
        value: tmpMän,
        isMessage: false
    });
    rader.push({
        namn: 'Kvinnor',
        value: tmpKvinnor,
        isMessage: false
    });
    return rader;
}
function urvalÅldersfördelningDatarad(urval: Urval) {
    const rader: Datarad[] = [];
    let tmpUnder25 = [];
    let tmp25_34 = [];
    let tmpÖver34 = [];
    tmpUnder25.push(String(urval.antagna24ÅrEllerYngre));
    tmpUnder25.push(String(urval.reserver24ÅrEllerYngre));
    tmp25_34.push(String(urval.antagna25Till34År));
    tmp25_34.push(String(urval.reserver25Till34År));
    tmpÖver34.push(String(urval.antagna35ÅrEllerÄldre));
    tmpÖver34.push(String(urval.reserver35ÅrEllerÄldre));
    rader.push({
        namn: 'Under 25',
        value: tmpUnder25,
        isMessage: false
    });
    rader.push({
        namn: '25-34',
        value: tmp25_34,
        isMessage: false
    });
    rader.push({
        namn: 'Över 34',
        value: tmpÖver34,
        isMessage: false
    });
    return rader;
}
function sokReserverAntagnaDatarad(sok: Sok) {
    const rader: Datarad[] = [];
    let tmpFörstahand = [];
    let tmpSökandeTotalt = [];
    tmpFörstahand.push(String(sok.förstahandsökande));
    tmpSökandeTotalt.push(String(sok.sökande));
    rader.push({
        namn: 'Förstahand',
        value: tmpFörstahand,
        isMessage: false
    });
    rader.push({
        namn: 'Sökande totalt',
        value: tmpSökandeTotalt,
        isMessage: false
    });
    return rader;
}
function sokKönsfördelningDatarad(sok: Sok) {
    const rader: Datarad[] = [];
    let tmpMän = [];
    let tmpKvinnor = [];
    tmpMän.push(String(sok.manligaSökande));
    tmpKvinnor.push(String(sok.kvinnligaSökande));
    rader.push({
        namn: 'Män',
        value: tmpMän,
        isMessage: false
    });
    rader.push({
        namn: 'Kvinnor',
        value: tmpKvinnor,
        isMessage: false
    });
    return rader;
}
function sokÅldersfördelningDatarad(sok: Sok) {
    const rader: Datarad[] = [];
    let tmpUnder25 = [];
    let tmp25_34 = [];
    let tmpÖver34 = [];
    tmpUnder25.push(String(sok.sökande24ÅrEllerYngre));
    tmp25_34.push(String(sok.sökande25Till34År));
    tmpÖver34.push(String(sok.sökande35ÅrEllerÄldre));
    rader.push({
        namn: 'Under 25',
        value: tmpUnder25,
        isMessage: false
    });
    rader.push({
        namn: '25-34',
        value: tmp25_34,
        isMessage: false
    });
    rader.push({
        namn: 'Över 34',
        value: tmpÖver34,
        isMessage: false
    });
    return rader;
}

</script>